"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RiskAreasRef = void 0;
const Field_type_1 = require("../../types/Field.type");
exports.RiskAreasRef = {
    priority: Number.MAX_VALUE,
    label: 'fields.enm.risk_areas.label',
    fallbackLabel: 'Risk areas',
    type: Field_type_1.FieldType.Enum,
    options: [
        { key: 'DUE_DILIGENCE', label: 'fields.enm.risk_areas.options.DUE_DILIGENCE', fallbackLabel: 'Due Diligence (Onboarding, Ongoing, Enhanced)' },
        { key: 'CUSTOMER_RISK_RATING', label: 'fields.enm.risk_areas.options.CUSTOMER_RISK_RATING', fallbackLabel: 'Customer Risk Rating' },
        { key: 'TRANSACTION_MONITORING', label: 'fields.enm.risk_areas.options.TRANSACTION_MONITORING', fallbackLabel: 'Transaction Monitoring' },
        { key: 'SANCTIONS', label: 'fields.enm.risk_areas.options.SANCTIONS', fallbackLabel: 'Sanctions' },
        { key: 'CREDIT_RISK', label: 'fields.enm.risk_areas.options.CREDIT_RISK', fallbackLabel: 'Credit Risk' },
        { key: 'HIGH_RISK_SEGMENTS', label: 'fields.enm.risk_areas.options.HIGH_RISK_SEGMENTS', fallbackLabel: 'High risk segments (if supported)' },
        { key: 'RECORD_RETENTION', label: 'fields.enm.risk_areas.options.RECORD_RETENTION', fallbackLabel: 'Record Retention' },
        { key: 'SUSPICIOUS_ACTIVITY_REPORTING', label: 'fields.enm.risk_areas.options.SUSPICIOUS_ACTIVITY_REPORTING', fallbackLabel: 'Suspicious Activity Reporting' },
        { key: 'PEP_SCREENING_AND_HANDLING', label: 'fields.enm.risk_areas.options.PEP_SCREENING_AND_HANDLING', fallbackLabel: 'PEP screening and handling' },
        { key: 'RISK_ASSESSMENT', label: 'fields.enm.risk_areas.options.RISK_ASSESSMENT', fallbackLabel: 'Risk Assessment (Business/Enterprise-wide Risk Assessment)' },
        { key: 'OTHER', label: 'fields.enm.risk_areas.options.OTHER', fallbackLabel: 'Other' },
    ],
    trackFieldValueWithAnalytics: false,
};
